<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu :active="active"></navMenu>
      <div class="content" v-loading.fullscreen.lock="loading">
        <div class="go-back" @click="goBack">返回</div>

        <!-- 表单信息 -->

        <div class="formContent">
          <div class="main-title">订单信息</div>
          <el-row>
            <el-col :xl="8" :lg="8">
              <div class="el-col_item">
                <span>订单号</span>
                <span>{{ details.sn }}</span>
              </div>
            </el-col>
            <el-col :xl="8" :lg="8">
              <div class="el-col_item">
                <span>名称</span>
                <span>{{ details.order_title }}</span>
              </div>
            </el-col>
            <el-col :xl="8" :lg="8">
              <div class="el-col_item">
                <span>创建时间</span>
                <span>{{ details.create_time }}</span>
              </div>
            </el-col>
            <el-col :xl="8" :lg="8">
              <div class="el-col_item">
                <span>支付方式</span>
<!--                2-微信支付  3-支付宝支付  4-对公转账-->
                <span>{{ details.pay_way==2?'微信支付':details.pay_way==3?'支付宝支付':'对公转账' }}</span>
              </div>
            </el-col>
            <el-col :xl="8" :lg="8">
              <div class="el-col_item">
                <span>状态</span>
                <span class="status sicon1" v-if="details.pay_status == 0"
                  >未支付</span
                >
                <span class="status sicon2" v-if="details.pay_status == 1"
                  >已支付</span
                >
              </div>
            </el-col>
            <el-col :xl="8" :lg="8">
              <div class="el-col_item">
                <span>支付时间</span>
                <span>{{ details.pay_time }}</span>
              </div>
            </el-col>
            <el-col :xl="8" :lg="8">
              <div class="el-col_item">
                <span>续费时长</span>
                <span>{{ details.buy_num }} 年</span>
              </div>
            </el-col>
            <el-col :xl="8" :lg="8">
              <div class="el-col_item">
                <span>应付金额</span>
                <span>{{ details.order_amount }}</span>
              </div>
            </el-col>
            <el-col :xl="8" :lg="8">
              <div class="el-col_item">
                <span>实付金额</span>
                <span>{{ details.actual_amount }}</span>
              </div>
            </el-col>
          </el-row>
          <div class="main-title">发票信息</div>
          <el-row>
            <el-col :span="8">
              <div class="el-col_item">
                <span>发票类型</span>
                <span>{{invoice_name}}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="el-col_item">
                <span>发票抬头</span>
                <span>{{details.invoice_information.header}}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="el-col_item">
                <span>抬头类型</span>
                <span>{{header_name}}</span>
              </div>
            </el-col>

          </el-row>
          <el-row>
            <el-col :span="8">
              <div class="el-col_item">
                <span>邮箱</span>
                <span>{{details.invoice_information.email}}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="el-col_item">
                <span>税号</span>
                <span>{{details.invoice_information.identification_code}}</span>
              </div>
            </el-col>
          </el-row>
<!--          <div class="main-title">收票人信息</div>-->
<!--          <el-row>-->
<!--            <el-col :xl="8" :lg="8">-->
<!--              <div class="el-col_item">-->
<!--                <span>姓名</span>-->
<!--                <span>姓名</span>-->
<!--              </div>-->
<!--            </el-col>-->
<!--            <el-col :xl="8" :lg="8">-->
<!--              <div class="el-col_item">-->
<!--                <span>手机</span>-->
<!--                <span>17625142543</span>-->
<!--              </div>-->
<!--            </el-col>-->
<!--            <el-col :xl="8" :lg="8">-->
<!--              <div class="el-col_item">-->
<!--                <span>所在地区</span>-->
<!--                <span>北京市</span>-->
<!--              </div>-->
<!--            </el-col>-->
<!--            <el-col :xl="8" :lg="8">-->
<!--              <div class="el-col_item">-->
<!--                <span>详细地址</span>-->
<!--                <span>浙江省湖州市南浔区上海街319号</span>-->
<!--              </div>-->
<!--            </el-col>-->
<!--          </el-row>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { orderDetail } from "@/api/api";
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue";
export default {
  components: { top, navMenu },
  data() {
    return {
      type: JSON.parse(localStorage.getItem("userdata")).type,
      active: 1,
      loading: false,
      sn: "", //订单号
      details: {},
      invoice_name: '',
      header_name: '',
      typeOptions: [
        {
          label: "全国性社会团体会费统一票据",
          value: 3,
        },
        {
          label: "普通发票",
          value: 1,
        },
        {
          label: "专用发票",
          value: 2,
        },
      ],
      headerOptions: [
        {
          label: "企业单位",
          value: 1,
        },
        {
          label: "个人/非企业单位",
          value: 2,
        },
      ],
    };
  },
  mounted() {
    let stepMenuList = JSON.parse(localStorage.getItem("menu"));
    this.stepMenuList = stepMenuList;
    var index = stepMenuList.findIndex(function (item) {
      return item.link_url == "/PaymentManagement";
    });
    this.active = index;
    this.mark = this.$route.query.mark;
    this.sn = this.$route.query.sn;
    //24.11.23 获取订单详情 dxm
    this.getDetail(this.sn);
  },
  created() {},
  watch: {},
  methods: {
    // 返回
    goBack() {
      this.$router.back();
    },
    timestampToDateString(timestamp) {
      if(timestamp){
        let num = Number(timestamp)
        const date = new Date(num * 1000);
        return date.toLocaleDateString().replaceAll('/','-')
      }else{
        return ''
      }

    },
    //24.11.23 获取订单详情 dxm
    getDetail(sn) {
      this.loading = true;
      orderDetail(
        this.$qs.stringify({
          type: this.type,
          sn,
        })
      )
        .then((res) => {
          this.loading = false;
          console.log(res, "===res");
          if (res.code == 1) {
            this.details = res.data;
            this.details.pay_time =this.timestampToDateString( this.details.pay_time)
            this.invoice_name= this.typeOptions.filter((item)=>{return item.value==this.details.invoice_information.invoice_type})[0].label
            this.header_name= this.headerOptions.filter((item)=>{return item.value==this.details.invoice_information.header_type})[0].label
          } else {
            this.$message.warning(res);
          }
        })
        .catch((err) => {
          if (err.response.code != 401) {
            this.$message.warning(err.response);
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-col_item {
  font-size: 14px;
  line-height: 24px;
  padding: 0 0 25px 35px;
}
.el-col_item :first-child {
  color: #7f8fa4;
  width: 60px;
  text-align: right;
  margin-right: 20px;
  display: inline-block;
}
.status {
  display: inline-block;
  width: 56px;
  height: 24px;
  border-radius: 6px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #ffffff;
  text-align: center;
  line-height: 24px;
}
.sicon1 {
  background: #ff4d4f;
}
.sicon2 {
  background: #0091ff;
}

.content {
  padding-bottom: 40px;

  .formContent {
    width: 100%;
    height: 100%;
    overflow: auto;
  }

  .main-title {
    margin: 30px 0 25px;
    padding-bottom: 18px;
    border-bottom: 1px solid #f0f2f5;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #354052;
  }

  .bus-formData {
    display: flex;
    flex-wrap: wrap;
    width: 100%;

    .el-row {
      width: 100%;
    }

    .el-form-item {
      width: 96%;
      margin-right: 60px;

      .el-select,
      .el-cascader {
        width: 100%;
      }

      .select {
        color: #1677ff;
        border-color: #1677ff;
      }

      .el-textarea__inner {
        border-radius: 9px;
      }
    }
  }
}
</style>
<style lang="scss">
@media only screen and (max-width: 767px) {
}
</style>